import { defineMessages } from 'react-intl';

export const labels = defineMessages({
  editInformation: {
    id: `user.details.labels.editInformation`,
    defaultMessage: 'Edit Information',
  },
  editProfile: {
    id: `user.details.labels.editProfile`,
    defaultMessage: 'Edit Profile',
  },
  editSocialLinks: {
    id: `user.details.labels.editSocialLinks`,
    defaultMessage: 'Edit Social Links',
  },
  editEthAddr: {
    id: `user.details.labels.editEthAddr`,
    defaultMessage: 'Edit Eth Address',
  },
  importLinkedIn: {
    id: `user.details.labels.importLinkedIn`,
    defaultMessage: 'Import LinkedIn Data',
  },
  addEthAddr: {
    id: `user.details.labels.addEthAddr`,
    defaultMessage: 'Add Eth Address',
  },
  logoutAllDevices: {
    id: `user.details.labels.logoutAllDevices`,
    defaultMessage: 'Logout From All Devices',
  },
  connectToMetamask: {
    id: `user.details.labels.connectToMetamask`,
    defaultMessage: 'Connect to Metamask',
  },
  bio: {
    id: `user.details.labels.bio`,
    defaultMessage: 'Bio',
  },
  readMore: {
    id: 'user.details.labels.readMore',
    defaultMessage: 'read more',
  },
});
